import { createAction, props } from '@ngrx/store';

export const loadAddressForCoordinates = createAction(
  '[Address] Load',
  props<{ keys: string[] }>(),
);

export const loadAddressSuccess = createAction(
  '[Address] Success',
  props<{ map: Record<string, string> }>(),
);

export const overwriteAddressMap = createAction(
  '[Address] Overwrite Address Map',
  props<{ map: Record<string, string> }>(),
);

export const loadAddressFailure = createAction('[Address] Failure', props<{ error: string }>());

export const triggerAddressCleanup = createAction('[Address] Trigger Cache Cleanup');
export const triggerAddressReload = createAction('[Address] Trigger Reload');
export const clearAddressCache = createAction('[Address] Clear Entire Cache');
